export const DEFAULT_PLATFORM_GROUP = 'all';
export const DEFAULT_COUNTRIES_GROUP = 'all';
